import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'マイアカウント',
  
  // form
  targetId: Constants.RegisterHash,
  values: {},
}

const getters = {
  get: state => state,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        case 'roleKbn':
          return Utility.getConstantsLabel(['UserRole'], value)
        case 'service':
          if (!value) return '全てのサービス'
          return value.serviceName
        case 'linkedCmss':
          if (!value || !value.length) return Constants.BlankValue
          return value.map(item => item.linkCMSName).join('、')
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {targetId, userParams}) {
    commit('setTargetId', targetId)

    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['user'],
        ['v1UserAccountGet'],
        [userParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('inited', res[0].data)
            console.log('values', state.values)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // init
  inited (state, data) {
    console.log('inited', data)
    console.log('inited', data.email)
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpEmail', data.email)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
